export default "__VITE_ASSET__CBDXIvPl__";